import React, { useState } from "react";
import {
  // Link,
  useNavigate,
} from "react-router-dom";

import NewButton from "../../components/uiMerge/newButton";
import { BrandLogo } from "../../components/shared/BrandLogo";
import { useBrand } from "../../hooks/useBrand";
import * as ROUTES from "../../constants/routes";
import { LoginModal } from "../../components/modals/loginModal";
import Carousel from "../../components/carousels/carousel";

// export const WelcomeScreen: React.FC = () => {

//   const [loginOpen, setLoginOpen] = useState<boolean>(false);
//   const navigate = useNavigate();

//   return (
//     <div className="h-screen overflow-hidden">
//       <div className="relative h-full ">
//         <Carousel />

//         <div className="absolute top-0 left-0 z-[9999] mt-[10%]">
//           <div className="flex-1 flex flex-col flex-start px-6">
//             <img src={Logo} className="w-[100px]" alt="" />
//           </div>
//         </div>

//         <div className="absolute bottom-0 z-[999] w-full bg-gradient-to-b from-black/0 via-black/80 to-black/100">
//           <div className="px-6 py-10 space-y-6 ">
//             <div className="space-y-2">
//               <NewButton
//                 fullWidth
//                 variant="primary"
//                 onClick={() => setLoginOpen(true)}
//               >
//                 Login
//               </NewButton>

//               <NewButton
//               fullWidth
//               variant="secondary"
//               onClick={() => navigate(ROUTES.REGISTER)}
//               // onClick={() => window.open("https://njoy.live?ref=calm-bear-n0yw", "_blank")}
//               >
//                 Register
//               </NewButton>
//             </div>

//             <div className="text-center">
//               <Link to="#" type="link" target="_blank" rel="noopener noreferrer">
//                 <p className="text-white text-xs opacity-70">
//                   Njoy Lite v1.0
//                 </p>
//               </Link>
//             </div>
//           </div>
//         </div>

//         <LoginModal
//           visible={loginOpen}
//           onCancel={() => setLoginOpen(false)}
//         />
//       </div>
//     </div>
//   );
// };

export const WelcomeScreen: React.FC = () => {
  const [loginOpen, setLoginOpen] = useState<boolean>(false);
  const { appName } = useBrand();
  const navigate = useNavigate();

  return (
    <div className="h-screen overflow-hidden">
      <div className="relative h-full ">
        

        {/* Logo */}
        <div className="absolute top-0 left-0 z-[9999] mt-[8%] sm:mt-[10%]">
          <div className="px-4 sm:px-6">
            <BrandLogo className="w-[80px] sm:w-[100px]" />
          </div>
        </div>
        

        <Carousel />

        {/* Bottom Section */}
        <div className="absolute bottom-0 z-[999] w-full bg-gradient-to-b from-black/0 via-black/80 to-black/100">
          <div className="px-4 sm:px-6 sm:py-4 space-y-4 sm:space-y-6  sm:mt-20">
            {/* Buttons */}
            <div className="space-y-2">
              <NewButton
                fullWidth
                variant="primary"
                onClick={() => setLoginOpen(true)}
              >
                Login
              </NewButton>

              <NewButton
                fullWidth
                variant="secondary"
                onClick={() => navigate(ROUTES.REGISTER)}
              >
                Register
              </NewButton>
            </div>

            {/* Version text (no link needed) */}
            <div className="text-center">
              <p className="text-white text-[10px] sm:text-xs opacity-70">
                {appName} Lite v1.0
              </p>
            </div>
          </div>
        </div>

        <LoginModal visible={loginOpen} onCancel={() => setLoginOpen(false)} />
      </div>
    </div>
  );
};
